import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

/**
 * CUSTOMIZATION: Quick Order is out of MVP Now — deep links redirect home.
 * Worksheet extension code remains in the repo but is not routable.
 */
const routes: Routes = [
  {
    path: 'custom-quickorder',
    redirectTo: '/home',
    pathMatch: 'prefix',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomQuickorderRoutingModule {}
